export const useAcvFetch = (endpoint, options) => {
  const config = useRuntimeConfig();
  const baseApi = config.public.BASE_API;
  const token = localStorage.getItem('access_token');

  return useFetch(endpoint, {
    baseURL: baseApi,
    ...options,

    async onResponse({ request, response, options }) {},
    async onResponseError({ request, response, options }) {},
    async onRequest({ request, options }) {},
    async onRequestError({ request, options, error }) {},
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};
